<patron-form [formGroup]="formGroup" (onSubmit)="onSubmit()">
  <div style="height: 100px">
    <patron-form-field [formGroup]="formGroup" formControlName="email" label="Email">
    </patron-form-field>
  </div>

  <div style="height: 100px">
    <patron-form-field
      [formGroup]="formGroup"
      formControlName="password"
      label="Nova senha"
      type="password">
    </patron-form-field>
  </div>

  <div style="height: 100px">
    <patron-form-field
      [formGroup]="formGroup"
      formControlName="confirm"
      label="Confirme a Senha"
      type="password">
    </patron-form-field>
  </div>

  <div class="row mt-2">
    <patron-button
      type="submit"
      [loading]="loading"
      customStyle="width: 100%"
      customClass="flex justify-content-center"
      class="w-full"
      iconName="bi-check2">
      Alterar senha
    </patron-button>

    <div class="mt-3">
      <patron-button
        iconName="bi-arrow-left"
        variant="outline"
        color="secondary"
        size="sm"
        routerLink="/auth">
        Voltar
      </patron-button>
    </div>
  </div>
</patron-form>
